/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PageRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let group = this.modelFor('group');
    return hash({
      group,
      page: this.store.findRecord('posts/page', params.page_id),
      postMeta: this.store.query('posts/post', {
        groupId: group.id,
        pageId: params.page_id,
        metaOnly: true,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('group/quick-comments').set(
      'currentPageId',
      model.page.id,
    );
    this.controllerFor('group/quick-comments/page').set('defaultPostTitle', '');
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('group/quick-comments').set('currentPageId', null);
  }

  setupController(controller) {
    super.setupController(...arguments);

    // Inject group route's controller so that we can controller the new-post popup.
    controller.set('groupController', this.controllerFor('group'));
  }
}
